import React, { Suspense, lazy, useMemo, useCallback } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAuth } from "@/hooks/useAuth";
import AnimatedLoader from "@components/AnimatedLoader";
import Home from "./Rootroute";
const Login = lazy(() => import("@/pages/auth/Login"));
const ForgetPassword = lazy(() => import("@/pages/auth/forgetpassword"));
const ErrorPage = lazy(() => import("./ErrorPage"));

// Guards and Routes
import OwnerGuard from "@routes/ownerroutes";
import OwnerRoutes from "@routes/ownerroutes/OwnerRoute";
import Superoutes from "@routes/superUser/Superoutes";
import SuperAdminGuard from "@routes/superUser";
import LandingLayout from "@/pages/landingpages";
import MPinPage from "@/pages/auth/Mpinpage";
import SetupPage from "@/pages/auth/SetupPage";
import AutoLoginHandler from "@/pages/auth/AutoLoginHandler";
const EmailMaritimeDashboard = React.lazy(() =>
  import("@/pages/Ownerpage/Dashboard/EmailDashboard")
);



const AppRoutes = () => {
  const { setupComplete } = useSelector((state) => state.ship);
  const { role } = useAuth();

  const roleBasedRoute = useMemo(() => {
    switch (role) {

      case "SUPERADMIN":
        return (
          <Route
            path="/superadmin/*"
            element={
              <SuperAdminGuard>
                <Superoutes />
              </SuperAdminGuard>
            }
          />
        );

      case "OWNER":
      case "OWNERGROUP":
      case "FLEET_MANAGER":
      case "VESSEL_MANANGER":
        return (
          <Route
            path="/management/*"
            element={
              <OwnerGuard>
                <OwnerRoutes />
              </OwnerGuard>
            }
          />
        );

      default:
        return null;
    }
  }, [role]);

  return (
    <Suspense fallback={setupComplete && <AnimatedLoader />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/site" element={<LandingLayout />} />

        {roleBasedRoute}
        <Route path="/login" element={<Login />} />
                <Route path="/auto-login" element={<AutoLoginHandler />} />

        <Route path="/dashboard/:ship_id" element={<EmailMaritimeDashboard />} />

        <Route path="/mpin" element={<MPinPage />} />
        <Route path="/setup" element={<SetupPage />} />
        <Route path="/changepassword" element={<ForgetPassword />} />
        <Route path="/restricted-access" element={<ErrorPage code={"403"} />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
